import { Component } from '@angular/core';
import { SlideupDirective } from '../../../directives/animations/slideup.directive';
import { Logo } from '../../common/logo/logo';

@Component({
  selector: 'section[app-about-us-section]',
  imports: [Logo, SlideupDirective],
  templateUrl: './about-us-section.html',
  styleUrl: './about-us-section.scss',
})
export class AboutUsSection {}
